module.exports = __webpack_public_path__ + "static/media/Calibre-RegularItalic.c408807a.ttf";